
let _ = require('../_.js');
let $ = jQuery;

let subscription = null;

// Handler for registration details modal.  Used in both clerk and auction details.

_.show_item_details_modal = async function (item) {
    $('#lp-modal-overlay').show();

    let $modal = $("#ac-modal-item-details");
    let auction = await item.auction.fetch();

    let show_item_details_modal_render = _.exclusive(async function () {

        // Set content
        // Title
        $modal.find("#ac-modal-item-details-title").text(item.title);

        // Photo
        let featuredPhoto = await item.featuredPhoto.fetch();

        if (featuredPhoto) {
            $modal.find("#ac-modal-item-details-photo-thumbnail").divimg(featuredPhoto);
            $modal.find("#ac-modal-item-details-photo-thumbnail-link").attr('href', featuredPhoto.direct_url);
        } else {
            $modal.find("#ac-modal-item-details-photo-thumbnail").divimg();
            $modal.find("#ac-modal-item-details-photo-thumbnail-link").attr('href', "#");
        }

        // Acres
        $modal.find("#ac-modal-item-details-acres").html(
            "<strong>" + _.property_noun_unit_plural_ucwords() + ":</strong> " + (item.acres ? item.acres : "---")
        );

        let vital_facts = [];

        let item_is_sold = false;

        if (item.acres) {
            vital_facts.push("<strong>" + _.property_noun_unit_plural_ucwords() + ":</strong> " +
                _.represent_units_with_plusminus(item.acres)
            );
        }

        if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
            vital_facts.push("<strong>Pricing Style:</strong>  Per " + _.property_noun_unit_singular_ucwords());
        } else if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
            vital_facts.push("<strong>Pricing Style:</strong>  Flat Price");
        }

        let round = item.auction_round.id ? await item.auction_round.fetch() : null;

        if (_.AuctionUI.auction_is_choice()) {
            vital_facts.push("<strong>Status:</strong> " + item.status_label);
            if (item.status == App_Models_AuctionItem.STATUS_SOLD && round && round.status == App_Models_AuctionRound.STATUS_SOLD) {
                item_is_sold = true;
            }
        } else {
            if (round) {
                vital_facts.push("<strong>Status:</strong> " + round.status_label);
                if (round.status == App_Models_AuctionRound.STATUS_SOLD) {
                    item_is_sold = true;
                }
            }
        }

        $modal.find("#ac-modal-item-details-vital-facts").html(vital_facts.join("&nbsp;&nbsp;&nbsp;&nbsp;"));

        // Description
        let description = item.description;

        // Set description, make all links open in new window
        $modal.find("#ac-modal-item-details-description").html(description);
        $modal.find("#ac-modal-item-details-description").find("a").attr("target", "_blank");


        // Gallery

        // Find round, if any.

        // // Effects for items with a round - either the item is on sale on its own, or bidding is complete.
        // if (round) {

        let $sale_status = $("#ac-modal-item-details-sale-status");
        let $sale_status_header = $(".item-details-heading-bids");
        let $sale_status_table = $("#ac-modal-details-details-table").find('tbody');

        $sale_status.hide();
        $sale_status_header.hide();
        $sale_status_table.empty();

        let best_price = null;

        let current_bid = null;

        if (round) {
            current_bid = await round.current_bid.fetch();
        }

        if (!current_bid && _.AuctionUI.auction_is_choice()) {
            let round = await _.ac_state.auction.current_round.fetch();
            if (round) {
                current_bid = await round.current_bid.fetch();
            }
        }

        if (item_is_sold) {
            $sale_status.show();
            $sale_status_header.show();
            $("#item-details-heading-bids").text("Sale Details");
            if (!current_bid) {
                $sale_status_table.append($("<tr><td colspan='2'>Error loading sale details.  Please contact AuctionCast if you have any questions.</td></tr>"));
            } else {
                $sale_status_table.append($("<tr><td>Winning Bidder:</td><td>" + (current_bid.paddle_number ? "[" + current_bid.paddle_number + "]" : "Floor") + "</td></tr>"));
                $sale_status_table.append($("<tr><td>Sale Price:</td><td>" + _.currency(item.sale_price) + "</td></tr>"));
                best_price = item.sale_price;
                if (auction.total_fees > 0) {
                    $sale_status_table.append($("<tr><td>Buyers Fees:</td><td>" + _.currency(item.fees_price) + "</td></tr>"));
                    $sale_status_table.append($("<tr><td>Total w/ Fees:</td><td>" + _.currency(item.sale_price_with_fees) + "</td></tr>"));
                }
                $("#ac-modal-details-fees-table-amount-label").text("Total");
            }
        } else if (!item_is_sold && round && current_bid) {
            // Bidding Status:
            $sale_status.show();
            $sale_status_header.show();
            $("#item-details-heading-bids").text("Bidding Details");
            best_price = current_bid.amount;
            if (!_.AuctionUI.auction_is_choice()) {
                $sale_status_table.append($("<tr><td>High Bidder:</td><td>" + (current_bid.paddle_number ? "[" + current_bid.paddle_number + "]" : "Floor") + " </td></tr>"));
            }
            if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                $sale_status_table.append($("<tr><td>Current Bid:</td><td>" + _.currency(current_bid.amount) + " / " +
                    _.property_noun_unit_singular_ucwords() + "</td></tr>"));
                $sale_status_table.append($("<tr><td>Total:</td><td>" + _.currency(current_bid.amount * item.acres) + "</td></tr>"));
                best_price = current_bid.amount * item.acres;
            } else {
                $sale_status_table.append($("<tr><td>Current Bid:</td><td>" + _.currency(current_bid.amount) + "</td></tr>"));
                best_price = current_bid.amount;
            }
            if (auction.total_fees > 0) {
                $sale_status_table.append($("<tr><td>Buyers Fees:</td><td>" + _.currency(current_bid.amount * (auction.total_fees / 100)) + "</td></tr>"));
                $sale_status_table.append($("<tr><td>Total /w Fees:</td><td>" + _.currency(current_bid.amount * (1 + (auction.total_fees / 100))) + "</td></tr>"));
            }
        } else {
            $sale_status.hide();
        }

        // Assuming auction.fees is a JSON string and auction.total_fees contains the total of all fees
        try {
            let feesArray = JSON.parse(auction.fees || '[]'); // Safely parse the JSON

            let fees_description = "";

            if (feesArray.length > 0 && auction.total_fees > 0) {

                $("#ac-modal-details-fees-container").show();

                let $table = $("#ac-modal-details-fees-table").find('tbody');
                $table.empty();

                feesArray.forEach(fee => {
                    console.log(fee);
                    let $row = $("<tr></tr>");
                    $row.append($("<td></td>").text(fee.amount + "%"));
                    $row.append($("<td></td>").text(fee.name));
                    $row.append($("<td></td>").text(best_price ? _.currency(best_price * (fee.amount / 100)) : ''));
                    $table.append($row);
                });

            } else {
                $("#ac-modal-details-fees-container").hide();
            }
        } catch (e) {
            console.error("Error parsing auction fees JSON: ", e);
            $("#ac-modal-details-fees-container").hide();
        }

    });

    await show_item_details_modal_render();
    await $modal.modal_show();
}

